import './Header.css';
import '../../../Generals/Styles/FormContainerStyle.css';
import { Col, Nav, Navbar } from 'react-bootstrap';
import { HashLink, NavHashLink } from 'react-router-hash-link';
import React, { useEffect, useRef, useState } from 'react';
import { faBars, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  isMobileMatchMedia,
  scrollToSectionWithOffset
} from '../../../Core/Hooks/HooksGenerals/UseMediaQuery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Logo } from '../../../Resources/Images/ImagesLogo';
import { TYPE_FETCH_PARAMETERS } from '../../../Domain/Settings/Constants/Constants';
import classNames from 'classnames';
import { useMediaQuery } from '../../../Core/Hooks/HooksGenerals/UseMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import GeneralSubElement from '../../Atoms/HeaderSubElement/GeneralSubElement';
import globeTraslate from '../../../assets/globeTraslate.svg';
import globeTraslateYellow from '../../../assets/globeTraslateYellow.svg';
import Spinner from '../../Atoms/Spinner/Spinner';
import { setLanguage } from '../../../Domain/Redux/Actions/Actions/ActionLenguageNavigator';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';
import {
  useGetComponentParameters,
  useGetComponentParametersSingle
} from '../../../Core/Hooks/HooksParameters/useGetComponentParameters';
import { setMobileMenuStyle } from '../../../Domain/Redux/Actions/Actions/ActionsMobileMenu';
import { useCombinedObjects } from '../../../Domain/Utils/ApiUtilies/Parameters/Parameters';
import useNavBar from '../../../Core/Hooks/HookNavbar/useNavBar';
import { handleNavigation } from '../../../Domain/Utils/UrlUtilies/UrlUtilies';
import LoadingHeader from '../../Atoms/LoadingHeader/LoaginsHeader';
import useNavBarMobile from '../../../Core/Hooks/HookNavbar/useNavBarMobile';
import { useHistory, withRouter, Link } from 'react-router-dom';

const _setLanguage = (browserLanguage, lenguagesList = [], dispatch) => {
  if (!lenguagesList?.length) {
    return;
  }

  const object_ = lenguagesList.find((item) => item.description === browserLanguage);
  dispatch(setLanguage(object_));
};
withRouter;
const Header = (props) => {
  // const history = useHistory();

  const parametersMlt = useGetComponentParameters(COMPONENTS.NAVIGATION_BAR);
  const parametersDetail = useGetComponentParametersSingle(
    COMPONENTS.NAVIGATION_BAR,
    TYPE_FETCH_PARAMETERS.DETAIL
  );

  const parameters = useCombinedObjects(parametersDetail, parametersMlt);
  const { showSearchWrapper, setShowSearchWrapper, handleClic } = props;
  const isBgTransparent = useSelector((store) => store.stylesState.transparentBackground);
  const language = useSelector((store) => store.languageTraslate.language);
  const lenguagesList = useSelector((store) => store.languageTraslate.languageList);

  const isMenuOpen = useSelector((store) => store.mobileMenu.mobileMenuOpened);

  const [expanded, setExpanded] = useState(false);
  const [isMenuCollapsable, setIsMenuCollapsable] = useState(true);
  const navbarRef = useRef(null);
  const [showTraslateOptions, setshowTraslateOptions] = useState(false);
  const [showTraslateOptionsMobile, setshowTraslateOptionsMobile] = useState(false);

  const width = useMediaQuery();
  const dispatch = useDispatch();

  const { mainNavBar, auxNavBar, fetchStrategicLine } = useNavBar(
    language,
    parameters,
    handleNavigation
  );

  const { mainNavBarMobile, auxNavBarMobile, fetchStrategicLineMobile } = useNavBarMobile(
    language,
    parameters,
    handleNavigation,
    isMenuCollapsable
  );

  useEffect(() => {
    if (!isMenuOpen) {
      setExpanded(false);
    }
  }, [isMenuOpen]);

  useEffect(() => {
    const matchedMedia = isMobileMatchMedia();
    const firedMatchMedia = () => {
      setIsMenuCollapsable(matchedMedia.matches);
    };
    firedMatchMedia();
  }, [width]);

  useEffect(() => {
    const matchedMedia = isMobileMatchMedia();
    const firedMatchMedia = () => {
      setIsMenuCollapsable(matchedMedia.matches);
    };
    firedMatchMedia();
    const handleClickOutsideNavbar = (event) => {
      if (!navbarRef?.current?.contains(event.target)) {
        // collapseMenu();
      }
    };
    matchedMedia.addEventListener('EventTarget', firedMatchMedia); // @see https://github.com/mdn/sprints/issues/858#issuecomment-515238645
    document.addEventListener('click', handleClickOutsideNavbar, {
      capture: true
    });

    return () => {
      matchedMedia.removeEventListener('EventTarget', firedMatchMedia);
      document.removeEventListener('click', handleClickOutsideNavbar, {
        capture: true
      });
    };
  }, []);

  useEffect(() => {
    if (!language.id) return;
    fetchStrategicLine();
    fetchStrategicLineMobile();
  }, [language]);

  const LogoLTNavbarBrand = () => (
    <Navbar.Brand className="logoNav">
      {/* // <Navbar.Brand className="me-auto "> */}
      <HashLink smooth scroll={scrollToSectionWithOffset} to="/home#top" rel="nofollow">
        <img src={parameters?.LOGO_NO_BG?.desktop_image || Logo} alt="Lite Thinking" />
      </HashLink>
    </Navbar.Brand>
  );

  const NavbarToggleOption = () => (
    <Navbar.Toggle
      // aria-controls="basic-navbar-nav-2"
      onClick={() => {
        setExpanded(!expanded);
        dispatch(setMobileMenuStyle(!expanded));
        setShowSearchWrapper(false);
      }}
      className="border-0 text-lt-yellow">
      <FontAwesomeIcon icon={expanded ? faTimes : faBars} />
    </Navbar.Toggle>
  );

  const GoogleSearchInput = () => (
    <Navbar
      onClick={() => {
        setShowSearchWrapper(!showSearchWrapper);
        setExpanded(false);
        dispatch(setMobileMenuStyle(false));
      }}
      className="border-0 items-intro-navbar">
      {parameters?.INF_MSG_146?.value && parameters?.INF_MSG_145?.value ? (
        <FontAwesomeIcon icon={showSearchWrapper ? faTimes : faSearch}></FontAwesomeIcon>
      ) : (
        <Spinner />
      )}

      {showSearchWrapper ? (
        <strong className="border-0 items-intro-navbar" style={{ marginLeft: '10px' }}>
          {' '}
          {parameters?.INF_MSG_146?.value}
        </strong>
      ) : (
        <strong className="border-0 items-intro-navbar" style={{ marginLeft: '10px' }}>
          {' '}
          {parameters?.INF_MSG_145?.value}
        </strong>
      )}
    </Navbar>
  );

  const isScroll = isBgTransparent && !isMenuCollapsable;

  return (
    <Navbar
      id="lt-navbar"
      ref={navbarRef}
      fixed="top"
      expand="lg"
      collapseOnSelect
      expanded={expanded}
      className={classNames('my-navbar p-0 shadow-md flex-column', {
        'bg-transparent': isScroll
      })}
      variant="dark">
      <div className="row col-12 nav-responsive-width navbar-intro py-2 py-lg-1 ">
        {isMenuCollapsable ? (
          <>
            <div className="col-8">
              <LogoLTNavbarBrand />
            </div>

            <div
              style={{ marginLeft: '20px' }}
              className="col-2 d-flex justify-content-center text-lt-yellow">
              <GoogleSearchInput />
            </div>
            <div className="col-2 border-0 d-flex justify-content-center">
              <NavbarToggleOption />
            </div>
          </>
        ) : (
          <>
            <Navbar.Collapse className="justify-content-end mx-0" style={{ maxHeight: '30px' }}>
              <Nav>
                {mainNavBar.length > 0 ? (
                  mainNavBar.map(({ id, to, onClick, label, iconLeft = null, link, isRedirect }) =>
                    isRedirect ? (
                      <Nav.Link
                        key={id}
                        to={to}
                        as={NavHashLink}
                        replace
                        smooth
                        scroll={scrollToSectionWithOffset}
                        onClick={onClick}
                        className="d-flex justify-content-center align-items-center text-center items-intro-navbar">
                        {iconLeft && (
                          <FontAwesomeIcon
                            icon={iconLeft.icon}
                            className={iconLeft.className || ''}
                          />
                        )}
                        {isMenuCollapsable ? <>{label}</> : <strong>{label}</strong>}
                      </Nav.Link>
                    ) : (
                      <Link
                        style={{ color: isBgTransparent ? 'white' : 'black' }}
                        key={id}
                        to={link}
                        as={NavHashLink}
                        replace
                        smooth
                        scroll={scrollToSectionWithOffset}
                        className="link-header d-flex justify-content-center align-items-center text-center items-intro-navbar">
                        {iconLeft && (
                          <FontAwesomeIcon
                            icon={iconLeft.icon}
                            className={iconLeft.className || ''}
                          />
                        )}
                        {isMenuCollapsable ? <>{label}</> : <strong>{label}</strong>}
                      </Link>
                    )
                  )
                ) : (
                  <LoadingHeader count={5} />
                )}
                <Nav.Link
                  aria-label="Search in Google API"
                  style={{ margin: '0', display: 'flex' }}>
                  <GoogleSearchInput />
                </Nav.Link>

                <Nav.Link aria-label="Change language">
                  <GeneralSubElement className="border-0 items-intro-navbar">
                    {
                      <>
                        <Navbar
                          aria-label="Button to select language text"
                          onClick={() => {
                            setshowTraslateOptions(!showTraslateOptions);
                            setExpanded(false);
                            dispatch(setMobileMenuStyle(false));
                          }}
                          className="border-0 items-intro-navbar">
                          <img
                            style={{ marginLeft: '0px' }}
                            className={classNames(
                              'my-navbar language-icon',
                              isScroll ? 'white-image-globe' : 'black-image-globe'
                            )}
                            src={globeTraslate}
                            alt="Globe Logo"
                          />
                          <strong>
                            <span aria-label="Button to select language text">
                              {language?.name}
                            </span>
                          </strong>
                        </Navbar>
                      </>
                    }
                  </GeneralSubElement>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
            <div
              className={classNames(
                'menu__lenguages-desktop my-navbar shadow-md flex-column',
                !isScroll ? '' : 'background__color-white',
                !isMenuCollapsable && showTraslateOptions ? 'container__list__lenaguage' : null
              )}>
              {!isMenuCollapsable && showTraslateOptions && (
                <>
                  {lenguagesList?.map(({ description, value, name }) => (
                    <p
                      key={description}
                      lg
                      xs="6"
                      className="container__list__lenaguage-text"
                      role={'button'}
                      onClick={() => {
                        _setLanguage(description, lenguagesList, dispatch);
                        setshowTraslateOptions(false);
                        setshowTraslateOptionsMobile(false);
                      }}>
                      {description === language?.description && <strong>{name}</strong>}
                      {description !== language?.description && name}
                    </p>
                  ))}
                </>
              )}
            </div>
          </>
        )}
      </div>
      <div className="col-12 nav-responsive-width navbar-primary py-0 py-lg-2">
        <Navbar.Collapse className="justify-content-between border-danger">
          {isMenuCollapsable ? (
            <>
              <div className="row">
                {auxNavBarMobile.length > 0 ? (
                  auxNavBarMobile.map(({ id, to, onClick, label }) => (
                    <Col key={id} lg xs="12" className="container-nav-link">
                      <Nav.Link
                        id={id}
                        to={to}
                        as={NavHashLink}
                        replace
                        smooth
                        scroll={scrollToSectionWithOffset}
                        onClick={onClick}
                        className="text-black border-0">
                        {isMenuCollapsable ? <>{label}</> : <strong>{label}</strong>}
                      </Nav.Link>
                    </Col>
                  ))
                ) : (
                  <LoadingHeader count={6} />
                )}
              </div>
              <div className="bg-black d-flex flex-column justify-content-center">
                {mainNavBarMobile?.length > 0 ? (
                  mainNavBarMobile.map(({ id, to, label, iconLeft = null }) => (
                    <div
                      key={id}
                      className="d-flex justify-content-center align-items-center text-center px-2">
                      <Nav.Link
                        to={to}
                        as={NavHashLink}
                        replace
                        smooth
                        scroll={scrollToSectionWithOffset}
                        className="text-lt-yellow py-2">
                        {iconLeft && (
                          <FontAwesomeIcon
                            icon={iconLeft.icon}
                            className={iconLeft.className || ''}
                          />
                        )}
                        {label}
                      </Nav.Link>
                    </div>
                  ))
                ) : (
                  <LoadingHeader count={6} backgroundColor="white" />
                )}
                <GeneralSubElement className="border-0 items-intro-navbar">
                  {
                    <>
                      <Navbar
                        onClick={() => {
                          setshowTraslateOptionsMobile(!showTraslateOptionsMobile);
                        }}
                        className="border-0 items-intro-navbar justify-content-center">
                        <img
                          className={classNames(
                            'text-lt-yellow my-navbar ',
                            isScroll ? 'white-image-globe' : 'black-image-globe'
                          )}
                          src={globeTraslateYellow}
                          alt="React Logo"
                        />
                        <span className="text-lt-yellow">{language?.name}</span>
                      </Navbar>
                    </>
                  }
                </GeneralSubElement>
              </div>
              {showTraslateOptionsMobile && (
                <div className="row">
                  {lenguagesList.map(({ description, value, name }) => (
                    <Col
                      key={description}
                      lg
                      xs="6"
                      className="container__list__lenaguage-mobile bg-black text-lt-yellow"
                      onClick={() => {
                        _setLanguage(description, lenguagesList, dispatch);
                        setshowTraslateOptions(false);
                        setshowTraslateOptionsMobile(false);
                      }}>
                      {description === language?.description && <strong>{name}</strong>}
                      {description !== language?.description && name}
                    </Col>
                  ))}
                </div>
              )}
            </>
          ) : (
            <>
              <LogoLTNavbarBrand />
              <Nav>
                {auxNavBar?.length > 0 ? (
                  auxNavBar.map(({ id, to, label, family = [] }) => (
                    <Nav.Link
                      id={id}
                      key={id}
                      to={to}
                      as={NavHashLink}
                      replace
                      smooth
                      scroll={scrollToSectionWithOffset}
                      className={`d-flex justify-content-center align-items-center text-center `}>
                      {label}
                    </Nav.Link>
                  ))
                ) : (
                  <LoadingHeader count={6} backgroundColor="white" />
                )}
              </Nav>
            </>
          )}
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default Header;
